import React from "react";
import { Button, Stack } from "@mui/material";

import { PROMPT_PRESETS } from "../TargetBuilderPanel.types";

interface QuickPresetButtonsProps {
  activePreset?: string;
  onApply: (presetKey: string) => void;
}

/**
 * Row of preset buttons for prompt-hierarchy quick selection.
 * Selected preset is rendered as `color="primary"`, others as `color="secondary"`.
 */
const QuickPresetButtons: React.FC<QuickPresetButtonsProps> = ({ activePreset, onApply }) => (
  <Stack direction="row" gap={2} flexWrap="wrap">
    {PROMPT_PRESETS.map((preset) => (
      <Button
        key={preset.key}
        size="small"
        variant="contained"
        color={activePreset === preset.key ? "primary" : "secondary"}
        onClick={() => onApply(preset.key)}
      >
        {preset.label}
      </Button>
    ))}
  </Stack>
);

export default QuickPresetButtons;
